import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getCasePhaseMeta, resolveCasePhase } from "../../app/helpers/flowCasePhaseHelper";
import { countFlowListTableColumns } from "../../app/helpers/flowModuleListUiHelper";

export { isCasePhaseTableField, getModuleListFieldHeaderLabel } from "../../app/helpers/flowModuleListUiHelper";

export const FlowListPhaseHeader = () => {
  const { t } = useTranslation();
  return (
    <th scope="col" className="th-table-cell-list">
      {t("flow.cmi.col.phase", "Fase")}
    </th>
  );
};

export const FlowListPhaseCell = ({ record, process = "" }) => {
  const { t } = useTranslation();
  const catalogRoles = useSelector((state) => state.catalogRole?.catalogRoles || []);
  const roleName = catalogRoles.find(
    (role) => Number(role.id) === Number(record?.current_role_catalog_id)
  )?.name;
  const phase = record?.case_phase || resolveCasePhase(record, {
    process: record?.process || process,
    roleName
  });
  const meta = getCasePhaseMeta(phase);
  return (
    <td>
      <span className={`badge bg-${meta.tone}`}>
        {t(meta.key, meta.fallback)}
      </span>
    </td>
  );
};

FlowListPhaseCell.propTypes = {
  record: PropTypes.object,
  process: PropTypes.string
};

export const FlowListEmptyRow = ({ colSpan = 1 }) => {
  const { t } = useTranslation();
  return (
    <tr>
      <td colSpan={colSpan} className="text-center text-muted py-4">
        {t("specialist.selection.pool.empty", "No hay registros con los filtros seleccionados.")}
      </td>
    </tr>
  );
};

FlowListEmptyRow.propTypes = {
  colSpan: PropTypes.number
};

export const resolveFlowListEmptyColSpan = (listFields, flowSelectionEnabled) =>
  countFlowListTableColumns(listFields, flowSelectionEnabled);

export default FlowListPhaseHeader;
